// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"65c4df10a3701991","3762":"9ba616332a3be372"}[chunkId] + ".css";
};